// extracted by mini-css-extract-plugin
export default {"task-reward-desc-wrapper":"task-reward-desc-wrapper_S_EC1"};